import { useRef, useState } from "react";
import { toast } from "sonner";
import {
  // ArrowContainer,
  LeftContent,
  StyledImage,
  UploadImageContainer,
  UploadImageButton,
  DeleteButton,
  OptionsContainer,
  OptionRow,
  OptionText,
  ToggleTrack,
  ToggleThumb,
  ContainerWrapper,
  CropButton,
  SectionLabel,
} from "./ImageToVideo.styles";

import { selectSelectedCollection } from "../../store/slices/model/slice";

import { ReactComponent as CropIcon } from "../../assets/icons/crop.svg";
import { useSelector } from "react-redux";
import { MAX_IMAGE_SIZE } from "../../utils/constants";
import heic2any from "heic2any";
import { useMediaQuery } from "react-responsive";
import { isImageOutput } from "../../utils/utils";

import LottieIcon from "../../components/LottieIcon/LottieIcon";
import deleteAnimation from "../../assets/animations/trash.json";
// import TermsCheckboxComponent from "../TermsCheckboxComponent/TermsCheckboxComponent";

const ImageToVideo = ({
  setIsOpenCropModal,
  setUploadedImage,
  uploadedImage,
  generateContainer,
  setNudifyEnabled,
  // agreeTos,
  // handleCheckboxClick,
  // showOutline,
  // shouldShake,
  uploadedImageRef,
  nudifyEnabled,
  upscaleEnabled,
  setUpscaleEnabled,
}) => {
  const fileInputRef = useRef();
  const collection = useSelector(selectSelectedCollection);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [widthDifference, setWidthDifference] = useState(null);
  const [hideImageContainer, setHideImageContainer] = useState(null);

  const checkWidthDifference = () => {
    setTimeout(() => {
      if (uploadedImageRef.current) {
        const imageWidth = uploadedImageRef.current.offsetWidth;
        const parentWidth = uploadedImageRef.current.parentElement.offsetWidth;
        const difference = parseInt((parentWidth - imageWidth) / 2);

        const maxDifference = isMobile ? 30 : 35;

        const hide = difference > 0 && difference < maxDifference;

        setWidthDifference(hide ? difference : 0);
        setHideImageContainer(hide);
      }
    }, 0);
  };

  if (!collection) {
    return null;
  }

  const input = collection.input;

  const handleFileChange = async (e) => {
    const { files } = e.target;

    let file = files[0];

    if (
      file &&
      [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/heic",
        "image/heif",
      ].includes(file.type)
    ) {
      if (file.size > MAX_IMAGE_SIZE) {
        toast.error("Image must be smaller than 20MB");
        return;
      }

      let blobToShow = file;

      if (file.type === "image/heic" || file.type === "image/heif") {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpg",
            quality: 0.9,
          });
          blobToShow = convertedBlob;

          file = new File(
            [convertedBlob],
            file.name.replace(/\.[^/.]+$/, ".jpg"),
            {
              type: "image/jpg",
              lastModified: Date.now(),
            },
          );
        } catch (err) {
          console.error("HEIC → jpg conversion failed", err);
          return;
        }
      }

      setUploadedImage({ file, url: URL.createObjectURL(blobToShow) });
    } else {
      toast.error("Unsupported media type.");
    }
  };

  return (
    <ContainerWrapper>
      <SectionLabel>Before</SectionLabel>
      <LeftContent>
        <UploadImageContainer>
          {uploadedImage && (
            <DeleteButton
              $shift={widthDifference}
              onClick={() => {
                setUploadedImage(null);
              }}
            >
              <LottieIcon
                animationData={deleteAnimation}
                trigger="hover"
                size={24}
              />
            </DeleteButton>
          )}
          {uploadedImage && (
            <CropButton
              $shift={widthDifference}
              onClick={() => {
                setIsOpenCropModal(true);
              }}
            >
              <CropIcon />
            </CropButton>
          )}

          <StyledImage
            ref={uploadedImageRef}
            src={
              uploadedImage?.url ||
              input.image.resizedImage.url ||
              input.image.url
            }
            $hideImageContainer={hideImageContainer || !uploadedImage}
            onLoad={checkWidthDifference}
          />

          <UploadImageButton onClick={() => fileInputRef.current?.click()}>
            Upload Image
          </UploadImageButton>

          <input
            type="file"
            ref={fileInputRef}
            accept="image/jpeg,image/jpg,image/png,image/webp,image/heic,image/heif"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </UploadImageContainer>
        {!isImageOutput(collection.modelName) && (
          <OptionsContainer>
            <OptionRow onClick={() => setNudifyEnabled(!nudifyEnabled)}>
              <OptionText>Nudify before scene</OptionText>
              <ToggleTrack $active={nudifyEnabled}>
                <ToggleThumb $active={nudifyEnabled} />
              </ToggleTrack>
            </OptionRow>
            <OptionRow onClick={() => setUpscaleEnabled(!upscaleEnabled)}>
              <OptionText>Upscale</OptionText>
              <ToggleTrack $active={upscaleEnabled}>
                <ToggleThumb $active={upscaleEnabled} />
              </ToggleTrack>
            </OptionRow>
          </OptionsContainer>
        )}

        {generateContainer}
        {/* <TermsCheckboxComponent
          handleCheckboxClick={handleCheckboxClick}
          agreeTos={agreeTos}
          shouldShake={shouldShake}
          showOutline={showOutline}
          offMarginTop
          offHorizontalMargin
        /> */}
      </LeftContent>
      {/* 
      <ArrowContainer>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.75 4.5L11.25 9L6.75 13.5"
            stroke="var(--color-brand-400)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ArrowContainer> */}
    </ContainerWrapper>
  );
};

export default ImageToVideo;
